import { styled } from "../../config/stiches.config";

export const Text = styled("p", {
  fontSize: "$2",
  fontFamily: "$inter",
  lineHeight: "$2",
  color: "$colors$gray900",
  textAlign: "center",
  verticalAlign: "middle",
  variants: {
    type: {
      label: {
        color: "$colors$gray700",
      },
      base: {
        color: "$colors$gray900",
      },
      light: {
        color: "$colors$gray400",
        cursor: "unset",
      },
      header: {
        fontSize: "$3",
        lineHeight: "$3",
        color: "$colors$gray900",
      },
      link: {
        color: "$colors$gray400",
        cursor: "pointer",
        ["&:hover"]: {
          color: "$colors$gray700",
        },
      },
      success: {
        color: "$colors$lime600",
      },
      successDark: {
        color: "$colors$lime700",
      },
      normal: {
        color: "$colors$gray500",
      },
    },
    size: {
      xsmall: {
        fontSize: "$1",
        lineHeight: "$1",
      },
      small: {
        fontSize: "$2",
        lineHeight: "$2",
      },
      base: {
        fontSize: "$3",
        lineHeight: "$3",
      },
      large: {
        fontSize: "$4",
        lineHeight: "$4",
      },
    },
    weight: {
      semiBold: {
        fontWeight: 400,
      },
      bold: {
        fontWeight: 500,
      },
      extraBold: {
        fontWeight: 600,
      },
      superBold: {
        fontWeight: 700,
      },
    },
  },
  defaultVariants: {
    type: "base",
  },
});

export const LabelForInput = styled("label", {
  fontSize: "$2",
  fontFamily: "$inter",
  lineHeight: "$2",
  color: "$colors$gray900",
  textAlign: "center",
  verticalAlign: "middle",
  variants: {
    type: {
      label: {
        color: "$colors$gray700",
      },
      base: {
        color: "$colors$gray900",
      },
      light: {
        color: "$colors$gray400",
        cursor: "unset",
      },
      header: {
        fontSize: "$3",
        lineHeight: "$3",
        color: "$colors$gray900",
      },
      link: {
        color: "$colors$gray400",
        cursor: "pointer",
        ["&:hover"]: {
          color: "$colors$gray700",
        },
      },
    },
    size: {
      xsmall: {
        fontSize: "$1",
        lineHeight: "$1",
      },
      small: {
        fontSize: "$2",
        lineHeight: "$2",
      },
      base: {
        fontSize: "$3",
        lineHeight: "$3",
      },
      large: {
        fontSize: "$4",
        lineHeight: "$4",
      },
    },
  },
  defaultVariants: {
    type: "base",
  },
});
